import styled from 'styled-components'

import { COLOR, NATIVE_BASE_COLORS, FONT_SIZE } from '../../../../themes'

export const StylesRepeatEvery = styled.div`
  display: flex;
  flex-direction: column;

  .layout {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .title {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.XS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
  }

  .repeat-every-layout {
    display: flex;
    align-items: center;
    margin-left: 16px;
    margin-right: 24px;
  }

  .repeat-every-input-box {
    width: 51px;
    height: 42px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background-color: ${NATIVE_BASE_COLORS.TEXT[200]};
    outline: none;
    border-color: transparent;
  }

  .repeat-every-input {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[700]};
    text-align: center;
  }

  .repeat-every-input {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[700]};
    text-align: center;
  }

  .dropdown-container {
    position: relative;
  }

  .dropdown-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${NATIVE_BASE_COLORS.TEXT[200]};
    background-color: ${NATIVE_BASE_COLORS.TEXT[200]};
    padding: 10px;
    cursor: pointer;
  }

  .dropdown-active-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: ${COLOR.BG_ACTIVE_DROPDOWN_REPEAT_BOOKING};
    padding: 10px;
  }

  .selected-option {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[700]};
    margin-right: 10px;
    cursor: pointer;
  }

  .option-layout {
    position: absolute;
    left: 0;
    top: 46;
    z-index: 2;
    width: 121px;
    height: auto;
    background-color: ${COLOR.WHITE};
    padding: 8px 0px;
    border-radius: 4px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.40);
  }

  .arrow-down {
    rotate: 180deg;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
  }
`
